/* eslint-disable @typescript-eslint/naming-convention */
import type { SiteHeader } from '@ps/web-martech-cms-types';
import { Link } from '@ps/web-shared-components';
import classNames from 'clsx';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { useRefs } from '@swf/core/providers/RefsProvider';
import { select } from '@swf/core/store';
import SideMenu from '@swf/layouts/StarsLayout/components/SideMenu/SideMenu';

import styles from './CMSHeaderV3.scss';
import AppDownloadBanner from './components/AppDownloadBanner/AppDownloadBanner';
import BrandIcon from './components/BrandIcon/BrandIcon';

const CMSHeaderV3: React.FC<SiteHeader> = ({
  layout = 'Real Money',
  secondary_navigation,
  brand_icon,
  brand_icon_url
}) => {
  const headerRef = useRef<HTMLDivElement>(null);
  const topHeaderRef = useRef<HTMLDivElement>(null);
  const { removeRef, setRefs } = useRefs();
  const isEmbedded = useSelector(select.device.isEmbedded);
  const embeddedRoute = useSelector(select.location.isEmbeddedRoute);
  const page = useSelector(select.cms.getPage);
  const showWebContent = !isEmbedded && !embeddedRoute;
  const clickableLogoUrl = page?.clickable_logo_url || brand_icon_url;

  useEffect(() => {
    setRefs('header', headerRef);
    setRefs('topHeader', topHeaderRef);

    return () => {
      removeRef('header');
      removeRef('topHeader');
    };
  }, [setRefs, removeRef]);

  return layout === 'Hidden' ? null : (
    <>
      {showWebContent && <AppDownloadBanner />}
      <header id="CMSheader" ref={headerRef} className={styles.header}>
        <div className={classNames(styles.menu)}>
          <div className={styles.brandIcon}>
            <Link href={clickableLogoUrl} track trackText="Brand Icon">
              <BrandIcon brandIcon={brand_icon} />
            </Link>
          </div>
          <SideMenu layout="horizontal" items={secondary_navigation} className={styles.sideMenu} />
        </div>
      </header>
    </>
  );
};

export default CMSHeaderV3;
